import { useRootDocument } from '~/core/shared/hooks';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import {
  AnyDocument,
  Evaluatable,
  WorkflowDataResolverDependencies,
} from '~/core/shared/types';
import { handleEvaluatableResolver } from './logic/handleEvaluatableResolver';

export const useEvaluatableResolver = () => {
  const rootDocument = useRootDocument();

  const evaluatableResolver = useEventHandler(
    (
      evaluatable: Evaluatable,
      dependencies?: Partial<WorkflowDataResolverDependencies>,
      parentContext?: AnyDocument,
    ) =>
      handleEvaluatableResolver(
        evaluatable,
        {
          rootDocument,
          ...dependencies,
        },
        parentContext,
      ),
  );

  return evaluatableResolver;
};
